"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SwitchItemContainer = _interopRequireDefault(require("./SwitchItemContainer"));
var _SwitchIndicator = _interopRequireDefault(require("./SwitchIndicator"));
var _arkReact = require("@dateam/ark-react");
const Switch = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    id,
    value,
    children,
    readOnly,
    onChange
  } = _ref;
  const containerRef = _react.default.useRef(null);
  const [indicatorStyle, setIndicatorStyle] = _react.default.useState({
    left: 0,
    width: 0,
    position: 0
  });
  const [nodeValueIdx, setNodeValueIdx] = _react.default.useState([]);
  const [dimensions, setDimensions] = _react.default.useState({
    height: window.innerHeight,
    width: window.innerWidth
  });
  _react.default.useEffect(() => {
    let timeoutRef = undefined;
    const debouncedHandleResize = () => {
      if (timeoutRef) {
        clearTimeout(timeoutRef);
        timeoutRef = undefined;
      }
      timeoutRef = setTimeout(() => {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        });
        timeoutRef = undefined;
      }, 100);
    };
    window.addEventListener('resize', debouncedHandleResize);
    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  });
  const handleSwitchClick = _react.default.useCallback(value => {
    if (readOnly === true) return;
    if (onChange) onChange(value);
  }, [onChange, readOnly]);
  const childrenItems = _react.default.useMemo(() => {
    let childIndex = 0;
    const tmpNodeValueIdx = [];
    const nodes = _react.default.Children.map(children, (child, index) => {
      if (! /*#__PURE__*/_react.default.isValidElement(child)) {
        return null;
      }
      const childValue = child.props.value === undefined ? childIndex.toString() : child.props.value;
      const selected = childValue === value;
      tmpNodeValueIdx.push(childValue);
      childIndex += 1;
      return /*#__PURE__*/_react.default.createElement(_SwitchItemContainer.default, {
        name: id,
        id: `${id}_${index}`,
        value: childValue,
        selected: selected,
        onClick: handleSwitchClick
      }, child);
    });
    setNodeValueIdx(tmpNodeValueIdx);
    return nodes;
  }, [children, handleSwitchClick, value]);
  _react.default.useEffect(() => {
    const childIdx = nodeValueIdx.findIndex(item => item === value);
    const tmpIndicatorStyle = {
      left: 0,
      width: 0,
      position: -1
    };
    if (childIdx !== -1 && containerRef.current) {
      const {
        children: tabsNode
      } = containerRef.current;
      if (childIdx < tabsNode.length) {
        const tabNode = tabsNode[childIdx];
        const containerRec = containerRef.current.getBoundingClientRect();
        const tabRec = tabNode.getBoundingClientRect();
        tmpIndicatorStyle.left = tabRec.left - containerRec.left;
        tmpIndicatorStyle.width = tabRec.width;
        tmpIndicatorStyle.position = childIdx;
      }
    }
    setIndicatorStyle(tmpIndicatorStyle);
  }, [value, containerRef, nodeValueIdx, dimensions]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)("switch", readOnly === true ? "switch-readOnly" : null)
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef,
    className: "switch-container"
  }, childrenItems), /*#__PURE__*/_react.default.createElement(_SwitchIndicator.default, {
    left: indicatorStyle.left,
    width: indicatorStyle.width,
    first: indicatorStyle.position === 0,
    last: indicatorStyle.position === nodeValueIdx.length - 1
  }));
});
Switch.displayName = 'Switch';
process.env.NODE_ENV !== "production" ? Switch.propTypes = {} : void 0;
Switch.defaultProps = {};
var _default = exports.default = Switch;